export const fullScreenExit16 = "M11 1v4h4v1h-5V1zM1 11h4v4h1v-5H1zm10 0h4v-1h-5v5h1zM5 5H1v1h5V1H5z";
